export default __webpack_public_path__ + "static/media/background_exercise.8fbea82e.svg";